import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, trackEvent } from '../lib/analytics';

// Tracks SPA page views on route change and delegates click tracking for
// WhatsApp Hotline and invite links.
export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  useEffect(() => {
    const onClick = (e) => {
      const anchor = e.target.closest && e.target.closest('a[href]');
      if (!anchor) return;
      const href = anchor.getAttribute('href') || '';
      if (href.includes('wa.me/27794984148')) {
        trackEvent('whatsapp_hotline_click', { link_url: href });
      } else if (href.includes('wa.me/?text')) {
        trackEvent('invite_click', { link_url: href });
      }
    };
    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, []);

  return null;
}
